import * as React from "react";
import { Scoreboards } from "../../../../../constants";
import { eBranches } from "sb-resp-lib";
import { ScoreboardProps, Scoreboard } from "../../Scoreboard";
import { renderMiniTeamsScore } from "./renderMiniTeamsScore";

export const renderMiniScore = (score1: string, score2: string, sportId: string, props: ScoreboardProps) =>
    Scoreboards[eBranches[sportId]]
        ? <Scoreboard {...props} />
        : renderMiniTeamsScore(score1, score2)